import { render } from "./TranslationsList.vue?vue&type=template&id=5d532b7c&scoped=true"
import script from "./TranslationsList.vue?vue&type=script&lang=js"
export * from "./TranslationsList.vue?vue&type=script&lang=js"

import "./TranslationsList.vue?vue&type=style&index=0&id=5d532b7c&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\craft-cms-3-plugins\\craft3-translate\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d532b7c"]])

export default __exports__